<template>
  <v-dialog v-model="openDialog"
            v-if="openDialog"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            lazy
            persistent
            max-width="500">
    <v-card class="pa-4">
      <v-toolbar>
        <v-toolbar-side-icon>
          <img height="24" width="24"
               src="/static/Quickbooks-Logo.png"/>
        </v-toolbar-side-icon>
        <v-layout column>
          <v-toolbar-title>Assign to QuickBooks Vendor</v-toolbar-title>
          <v-list-tile-sub-title class="font-italic">
            Assignable loads: {{planningLoadGroupAvailableTruckCount(load)}}
          </v-list-tile-sub-title>
        </v-layout>
      </v-toolbar>
      <v-layout column pt-3>
        <span class="title mb-2">Outside Vendors</span>
        <v-select
          :items="planningLoadGroupAvailableLoadAssignmentRangeOptions(load)"
          v-model.number="assignTruckCount"
          label="Assigned Truck Count">
        </v-select>

        <v-checkbox
          :prepend-icon="includeCustomerIcon"
          :label="includeCustomerIconLabel"
          v-model="includeCustomerOnDispatch"
        />

        <v-select-quickbooks-company vendor
                                     :error-messages="errors.first('vendor')"
                                     data-vv-as="Vendor"
                                     data-vv-name="vendor"
                                     v-validate="'required'"
                                     :company="company"
                                     v-model="assignedVendor">
        </v-select-quickbooks-company>

        <v-float-field :label="outsideVendorPaymentLabel"
                       :error-messages="errors.first('amount')"
                       data-vv-as="Amount"
                       data-vv-name="amount"
                       v-validate="'required'"
                       class="mt-3"
                       v-model="vendorPayableAmount"/>

        <v-subheader class="pl-0">Optionally, add a note to the transaction history:</v-subheader>
        <v-textarea
          name="input-7-4"
          label="Internal Billing Instructions"
          v-model="billingInstructions"
        />

        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 :loading="loadingBtn"
                 :disabled="errors.any()"
                 @click="assignVendor()">
            Assign
          </v-btn>
          <v-btn color="accent" flat
                 @click="openDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

import API from '@/api/index';
import VSelectQuickbooksCompany from '@/components/qb/SelectQuickbooksCompany';
import VFloatField from '@/components/VFloatField';
import planningLoadGroupsMixin from '@/mixins/planningLoadGroupsMixin';

export default {
  name: 'VendorDispatchDialog',
  props: {
    value: {
      type: Boolean,
    },
    load: {
      type: Object,
    },
    company: {
      type: Object,
    },
  },
  mixins: [
    planningLoadGroupsMixin,
  ],
  components: {
    VSelectQuickbooksCompany,
    VFloatField,
  },
  data() {
    return {
      openDialog: this.value,
      assignTruckCount: 1,
      assignedVendor: null,
      billingInstructions: null,
      vendorPayableAmount: null,
      includeCustomerOnDispatch: true,
      loadingBtn: false,
    };
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  computed: {
    _() {
      return _;
    },
    includeCustomerIcon() {
      return this.includeCustomerOnDispatch ? 'person_add' : 'person_add_disabled';
    },
    outsideVendorPaymentLabel() {
      const amount = this.load.loadGroup.amount;
      if (amount != null) {
        const customerName = this.loadGroupCustomerCompanyName(this.load) || 'customer';
        return `Vendor Agreement (invoices $${amount} to ${customerName} )`;
      }
      return 'Vendor Agreement (in $)';
    },
    includeCustomerIconLabel() {
      return `Include Customer on Load Details and ${this.$t('terms.bill-of-lading')}`;
    }
  },
  methods: {
    resetForm() {
      this.assignTruckCount = 1;
      this.assignedVendor = null;
      this.billingInstructions = null;
      this.vendorPayableAmount = null;
      this.includeCustomerOnDispatch = true;
    },
    async assignVendor() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.loadingBtn = true;

        const load = {
          companyId: this.load.loadGroup.details.listingCompany.id,
          truckCount: this.assignTruckCount,
          qbVendorId: this.assignedVendor.qbCompanyId,
          qbVendorName: this.assignedVendor.selectDisplay,
          payableAmount: this.vendorPayableAmount,
          notes: this.billingInstructions,
          includeCustomerOnLoad: this.includeCustomerOnDispatch,
        };

        try {
          const apiResponse = await API.planner.assignQbVendor({
            loadId: this.load.humanId,
            body: load,
          });

          this.$store.dispatch('applications/setSuccessNotification', {
            message: `Assigned to ${load.qbVendorName}`,
            timeout: 4000,
          });

          this.$emit('refresh', apiResponse);
          this.openDialog = false;

          // dispatch board resets when booked loads are refreshed. nothing to do there.
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.loadingBtn = false;
        }
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/VendorDispatchDialog.vue